"use strict";
/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */

module.exports = function () {
    return [["aan de ene kant", "aan de andere kant"], ["enerzijds", "anderzijds"], ["natuurlijk", "maar"], ["niet alleen", "maar ook"], ["noch", "noch"], ["zowel", "als"]];
};
//# sourceMappingURL=twoPartTransitionWords.js.map
//# sourceMappingURL=twoPartTransitionWords.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/dutch/twoPartTransitionWords.js
// module id = 414
// module chunks = 0